export default __webpack_public_path__ + "static/media/Ring of Amra the Lion.95d96344.jpg";